export default "__VITE_ASSET__8fqpkLb09KWHW2eUHkTnxg__";